module.exports = __webpack_public_path__ + "img/header_gels.5b17b277.jpg";